/* eslint-disable @typescript-eslint/naming-convention */
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { IContactApiProps } from '@boxx/contacts-core';
import { IHttpBasicResponse, JsonApiResponse } from '@boxx/core';
import { IEventsApiProps } from '@boxx/events-core';
import { ILeadApi, IReviewsApi } from '@boxx/messages-core';
import { IEcwidDataStatistics } from '@boxx/gmb-core/lib/contracts/IEcwidData';

export interface IPanelRepository {
  getPanelData(): Observable<IHttpBasicResponse<IPanelApiResponse>>;
  getPanelAnalytics(
    filter?: IPanelAnalyticsPayload
  ): Observable<JsonApiResponse<IPanelAnalyticsResponse>>;
  getPanelContacts(): Observable<IHttpBasicResponse<any>>;
  getPanelEvents(): Observable<IHttpBasicResponse<any>>;
  getPanelLeads(): Observable<IHttpBasicResponse<any>>;
  getPanelReviews(): Observable<IHttpBasicResponse<IReviewsApi>>;
  getEcwidStadistics(): Observable<JsonApiResponse<IEcwidDataStatistics>>;
  refreshEcwidStadistics(startDate: string, enDate: string): Observable<JsonApiResponse<IEcwidDataStatistics>>;
  activateNFC(payload: any): Observable<JsonApiResponse<any>>;
  getNFCDevices(): Observable<any>;
}

export const PANEL_REPOSITORY = new InjectionToken<IPanelRepository>(
  'panelRepository'
);

export interface IPanelAnalyticsPayload {
  start_date?: string;
  end_date?: string;
  period: 'year' | 'month' | 'week' | 'day' | 'range';
}

export interface IPanelAnalyticsGeneralResponse {
  avg_time_on_site: number;
  bounce_count: number;
  bounce_rate: string;
  max_actions: number;
  nb_actions: number;
  nb_actions_per_visit: number;
  nb_visits: number;
  nb_visits_converted: number;
  sum_visit_length: number;
}

export type IPanelAnalyticsResponse =
  | IPanelAnalyticsGeneralResponse
  | AnalyticsByPeriod;

type AnalyticsByPeriod = {
  [key: string]: [] | IPanelAnalyticsGeneralResponse;
};

//UNUSED INTERFACE!!!!
export interface IPanelApiResponse {
  analytics: { page_views: string };
  contacts: {
    recent_contacts: Array<IContactApiProps>;
    stats: {
      clients: string;
      not_specified: string;
      prospects: string;
      total: string;
    };
  };
  form_messages: {
    last_received: Array<ILeadApi>;
    stats: {
      read: string;
      total: string;
      unread: string;
    };
  };
  schedule: {
    stats: { total: string };
    upcoming_events: Array<IEventsApiProps>;
  };
}
